module.exports = __webpack_public_path__ + "static/media/costQuestion.4c017f68.mp3";